(function () {
  'use strict';

  var sbbNamespace = window.__SBB__ = window.__SBB__ || {};
  var ScaleBarBuilder = sbbNamespace.ScaleBarBuilder;
  var clamp = sbbNamespace.clamp;
  var parseNumber = sbbNamespace.parseNumber;
  var deepClone = sbbNamespace.deepClone;
  var stripMediaFromStateSnapshot = sbbNamespace.stripMediaFromStateSnapshot;
  var stripComputedFieldsFromStateSnapshot = sbbNamespace.stripComputedFieldsFromStateSnapshot;
  var roundNumbersDeep = sbbNamespace.roundNumbersDeep;
  var mapObjectKeysDeep = sbbNamespace.mapObjectKeysDeep;
  var INFO_OVERLAY_DIMMED_OPACITY = sbbNamespace.infoOverlayDimmedOpacity;
  var SESSION_STORAGE_KEY = sbbNamespace.sessionStorageKey;
  var SESSION_VERSION = sbbNamespace.sessionVersion;
  var MAX_SESSION_BYTES = sbbNamespace.maxSessionBytes;
  var SHARE_VERSION = sbbNamespace.shareVersion;
  var SHARE_HASH_PREFIX = sbbNamespace.shareHashPrefix;
  var SHARE_NUMBER_DECIMALS = sbbNamespace.shareNumberDecimals;
  var SHARE_KEY_MAP = sbbNamespace.shareKeyMap;
  var SHARE_KEY_MAP_REVERSE = sbbNamespace.shareKeyMapReverse;
  var TEMPLATE_STORAGE_KEY = sbbNamespace.templateStorageKey;
  var TEMPLATE_VERSION = sbbNamespace.templateVersion;
  var lzCompressToUriSafe = sbbNamespace.lzCompressToUriSafe;
  var lzDecompressFromUriSafe = sbbNamespace.lzDecompressFromUriSafe;
  if (!ScaleBarBuilder || !clamp || !parseNumber || !deepClone || !stripMediaFromStateSnapshot || !stripComputedFieldsFromStateSnapshot || !roundNumbersDeep || !mapObjectKeysDeep || !INFO_OVERLAY_DIMMED_OPACITY || !SESSION_STORAGE_KEY || !SESSION_VERSION || !MAX_SESSION_BYTES || !SHARE_VERSION || !SHARE_HASH_PREFIX || !SHARE_NUMBER_DECIMALS || !SHARE_KEY_MAP || !SHARE_KEY_MAP_REVERSE || !TEMPLATE_STORAGE_KEY || !TEMPLATE_VERSION || !lzCompressToUriSafe || !lzDecompressFromUriSafe) {
    return;
  }

ScaleBarBuilder.prototype.getSerializableState = function (options) {
    var includeMedia = !options || options.includeMedia !== false;
    var state = deepClone(this.state);
    state.shareWarnings = [];
    state.sessionVersion = SESSION_VERSION;

    if (!includeMedia) {
      stripMediaFromStateSnapshot(state);
    }
    return state;
  };

  ScaleBarBuilder.prototype.stripShareRuntimeFields = function (state) {
    if (!state || typeof state !== 'object') {
      return state;
    }
    delete state.selectedEntity;
    delete state.activeTool;
    delete state.viewZoom;
    delete state.viewCenterXmm;
    delete state.viewCenterYmm;
    delete state.sidebarCollapsed;
    delete state.autosaveEnabled;
    delete state.lastSavedAt;
    delete state.sessionVersion;
    delete state.shareWarnings;
    delete state.homeSetMode;
    return state;
  };

  ScaleBarBuilder.prototype.stripShareDefaultAssets = function (state) {
    if (!state || typeof state !== 'object') {
      return state;
    }
    if (Array.isArray(state.overlayItems)) {
      state.overlayItems = state.overlayItems.filter(function (item) {
        if (!item || typeof item !== 'object') {
          return false;
        }
        if (item.type === 'logo' || item.type === 'info') {
          return false;
        }
        if ((item.type === 'image' || item.type === 'logo') && typeof item.srcDataUrl === 'string' && /^data:/i.test(item.srcDataUrl)) {
          delete item.srcDataUrl;
        }
        return true;
      });
    }
    if (state.background && typeof state.background === 'object') {
      if (typeof state.background.imageDataUrl === 'string' && /^data:/i.test(state.background.imageDataUrl)) {
        state.background.imageDataUrl = '';
      }
    }
    return state;
  };

  ScaleBarBuilder.prototype.removeShareDefaults = function (state, defaults) {
    if (!state || typeof state !== 'object') {
      return {};
    }
    var base = defaults && typeof defaults === 'object' ? defaults : {};
    var trimmed = deepClone(state);
    Object.keys(trimmed).forEach(function (key) {
      if (!Object.prototype.hasOwnProperty.call(base, key)) {
        return;
      }
      if (JSON.stringify(trimmed[key]) === JSON.stringify(base[key])) {
        delete trimmed[key];
      }
    });
    return trimmed;
  };

  ScaleBarBuilder.prototype.buildShareStateSnapshot = function (sourceState, includeDefaults) {
    var state = deepClone(sourceState || this.state);
    this.stripShareRuntimeFields(state);
    stripComputedFieldsFromStateSnapshot(state);
    this.stripShareDefaultAssets(state);
    if (includeDefaults) {
      return state;
    }
    return this.removeShareDefaults(state, this.shareBaseState || {});
  };

  ScaleBarBuilder.prototype.packShareState = function (shareState) {
    var state = deepClone(shareState || {});
    if (Array.isArray(state.overlayItems)) {
      state.overlayItems.forEach(function (item) {
        if (!item || item.type !== 'text') {
          return;
        }
        if (Number.isFinite(parseNumber(item.fontSizePt, NaN))) {
          delete item.fontSizeMm;
        }
      });
    }
    state = roundNumbersDeep(state, SHARE_NUMBER_DECIMALS);
    return mapObjectKeysDeep(state, SHARE_KEY_MAP);
  };

  ScaleBarBuilder.prototype.unpackShareState = function (packedState) {
    var state = mapObjectKeysDeep(packedState || {}, SHARE_KEY_MAP_REVERSE);
    if (Array.isArray(state.overlayItems)) {
      for (var i = 0; i < state.overlayItems.length; i += 1) {
        var item = state.overlayItems[i];
        if (!item || item.type !== 'text') {
          continue;
        }
        if (!Number.isFinite(parseNumber(item.fontSizePt, NaN)) && Number.isFinite(parseNumber(item.fontSizeMm, NaN))) {
          item.fontSizePt = this.mmToPt(item.fontSizeMm);
        }
      }
    }
    return state;
  };

  ScaleBarBuilder.prototype.makeTemplateId = function (name, fallbackIndex) {
    var base = String(name || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    if (!base) {
      base = 'template-' + String(Math.max(1, parseInt(fallbackIndex, 10) || 1));
    }
    if (/^\d/.test(base)) {
      base = 't-' + base;
    }
    return base.slice(0, 64);
  };

  ScaleBarBuilder.prototype.extractStateFromShareHash = function (text) {
    var raw = String(text || '').trim();
    if (!raw) {
      return null;
    }
    var hash = raw;
    if (hash.indexOf(SHARE_HASH_PREFIX) !== 0) {
      var idx = hash.indexOf(SHARE_HASH_PREFIX);
      if (idx >= 0) {
        hash = hash.slice(idx);
      } else if (hash.indexOf(SHARE_HASH_PREFIX.slice(1)) === 0) {
        hash = '#' + hash;
      } else {
        return null;
      }
    }
    try {
      var encoded = hash.slice(SHARE_HASH_PREFIX.length);
      var decoded = lzDecompressFromUriSafe(encoded);
      if (!decoded) {
        return null;
      }
      var parsed = JSON.parse(decoded);
      if (!parsed || parsed.v !== SHARE_VERSION || !parsed.s) {
        return null;
      }
      return this.unpackShareState(parsed.s);
    } catch (error) {
      return null;
    }
  };

  ScaleBarBuilder.prototype.normalizeTemplateDefinition = function (definition, index) {
    var fallbackName = 'Template ' + String((index || 0) + 1);
    var raw = definition;
    if (typeof raw === 'string') {
      raw = {
        name: fallbackName,
        shareHash: raw
      };
    }
    if (!raw || typeof raw !== 'object') {
      return null;
    }

    var state = null;
    if (raw.state && typeof raw.state === 'object') {
      state = deepClone(raw.state);
    } else {
      state = this.extractStateFromShareHash(raw.shareHash || raw.shareUrl || raw.url || '');
    }
    if (!state || typeof state !== 'object') {
      return null;
    }

    var name = String(raw.name || fallbackName).trim() || fallbackName;
    var id = String(raw.id || this.makeTemplateId(name, index || 1)).trim();
    if (!id) {
      id = this.makeTemplateId(name, index || 1);
    }

    state.sessionVersion = SESSION_VERSION;
    state.shareWarnings = [];

    return {
      version: TEMPLATE_VERSION,
      id: id,
      name: name,
      description: String(raw.description || '').trim(),
      state: state
    };
  };

  ScaleBarBuilder.prototype.rebuildTemplateLibraryIndex = function () {
    this.templateLibraryById = {};
    var maxCounter = 1;
    for (var i = 0; i < this.templateLibrary.length; i += 1) {
      var item = this.templateLibrary[i];
      if (!item || !item.id) {
        continue;
      }
      this.templateLibraryById[item.id] = item;
      var m = /template-(\d+)$/.exec(item.id);
      if (m) {
        maxCounter = Math.max(maxCounter, parseInt(m[1], 10) + 1);
      }
    }
    this.templateCounter = maxCounter;
    this.syncTemplateSelector();
  };

  ScaleBarBuilder.prototype.getConfiguredTemplateDefinitions = function () {
    var out = [];
    var addAny = function (value) {
      if (!value) {
        return;
      }
      if (Array.isArray(value)) {
        for (var i = 0; i < value.length; i += 1) {
          out.push(value[i]);
        }
        return;
      }
      if (value && typeof value === 'object' && Array.isArray(value.templates)) {
        for (var t = 0; t < value.templates.length; t += 1) {
          out.push(value.templates[t]);
        }
        return;
      }
      if (value && typeof value === 'object') {
        out.push(value);
      }
    };

    addAny(window.SBB_TEMPLATE_LIBRARY);

    if (this.root) {
      var templateKey = this.root.getAttribute('data-sbb-templates-key');
      if (templateKey && window[templateKey]) {
        addAny(window[templateKey]);
      }
      var templateJsonText = this.root.getAttribute('data-sbb-templates-json');
      if (templateJsonText) {
        var parsedTemplateJson = parseJsonObject(templateJsonText);
        addAny(parsedTemplateJson);
      }
    }

    return out;
  };

  ScaleBarBuilder.prototype.loadTemplateLibraryFromLocal = function () {
    try {
      var raw = localStorage.getItem(TEMPLATE_STORAGE_KEY);
      if (!raw) {
        return [];
      }
      var parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        return parsed;
      }
      if (!parsed || typeof parsed !== 'object') {
        return [];
      }
      if (parsed.version !== TEMPLATE_VERSION || !Array.isArray(parsed.templates)) {
        return [];
      }
      return parsed.templates;
    } catch (error) {
      return [];
    }
  };

  ScaleBarBuilder.prototype.saveTemplateLibraryToLocal = function () {
    try {
      var templates = [];
      for (var i = 0; i < this.templateLibrary.length; i += 1) {
        var item = this.templateLibrary[i];
        if (!item || !item.id || !item.state) {
          continue;
        }
        var saved = {
          version: TEMPLATE_VERSION,
          id: item.id,
          name: item.name,
          description: item.description || '',
          state: deepClone(item.state)
        };
        stripMediaFromStateSnapshot(saved.state);
        templates.push(saved);
      }
      var payload = {
        version: TEMPLATE_VERSION,
        savedAt: Date.now(),
        templates: templates
      };
      localStorage.setItem(TEMPLATE_STORAGE_KEY, JSON.stringify(payload));
      return true;
    } catch (error) {
      return false;
    }
  };

  ScaleBarBuilder.prototype.registerTemplateDefinitions = function (definitions, options) {
    var opts = options || {};
    var list = Array.isArray(definitions) ? definitions : [definitions];
    var added = 0;
    var updated = 0;
    var skipped = 0;
    var replaceExisting = opts.replaceExisting !== false;

    for (var i = 0; i < list.length; i += 1) {
      var normalized = this.normalizeTemplateDefinition(list[i], i);
      if (!normalized) {
        skipped += 1;
        continue;
      }

      var replaced = false;
      for (var j = 0; j < this.templateLibrary.length; j += 1) {
        if (this.templateLibrary[j] && this.templateLibrary[j].id === normalized.id) {
          if (replaceExisting) {
            this.templateLibrary[j] = normalized;
            updated += 1;
          } else {
            skipped += 1;
          }
          replaced = true;
          break;
        }
      }
      if (!replaced) {
        this.templateLibrary.push(normalized);
        added += 1;
      }
    }

    this.rebuildTemplateLibraryIndex();

    if (opts.persist !== false) {
      this.saveTemplateLibraryToLocal();
    }

    return {
      added: added,
      updated: updated,
      skipped: skipped,
      total: this.templateLibrary.length
    };
  };

  ScaleBarBuilder.prototype.clearTemplateLibrary = function (options) {
    var opts = options || {};
    this.templateLibrary = [];
    this.templateLibraryById = {};
    this.templateCounter = 1;
    this.templateSelectSignature = '';
    this.selectedTemplateId = '';
    this.syncTemplateSelector();

    if (opts.persist !== false) {
      try {
        localStorage.removeItem(TEMPLATE_STORAGE_KEY);
      } catch (error) {
        return false;
      }
    }
    return true;
  };

  ScaleBarBuilder.prototype.loadTemplateLibrary = function () {
    this.clearTemplateLibrary({ persist: false });
    var configured = this.getConfiguredTemplateDefinitions();
    if (configured.length) {
      this.registerTemplateDefinitions(configured, {
        replaceExisting: true,
        persist: false
      });
    }
    var localTemplates = this.loadTemplateLibraryFromLocal();
    if (localTemplates.length) {
      this.registerTemplateDefinitions(localTemplates, {
        replaceExisting: true,
        persist: false
      });
    }
    this.rebuildTemplateLibraryIndex();
    this.syncTemplateSelector();
  };

  ScaleBarBuilder.prototype.getTemplateById = function (templateId) {
    if (!templateId) {
      return null;
    }
    return this.templateLibraryById[String(templateId)] || null;
  };

  ScaleBarBuilder.prototype.getTemplateList = function () {
    var list = [];
    for (var i = 0; i < this.templateLibrary.length; i += 1) {
      var item = this.templateLibrary[i];
      if (!item) {
        continue;
      }
      list.push({
        id: item.id,
        name: item.name,
        description: item.description || '',
        version: item.version || TEMPLATE_VERSION
      });
    }
    return list;
  };

  ScaleBarBuilder.prototype.syncTemplateSelector = function () {
    if (!this.controls.templateSelect) {
      return;
    }
    var list = this.getTemplateList();
    var signature = list.map(function (item) {
      return item.id + ':' + item.name;
    }).join('|');
    if (signature === this.templateSelectSignature && this.controls.templateSelect.options.length === list.length + 1) {
      return;
    }

    var preferredValue = this.selectedTemplateId || this.controls.templateSelect.value || '';
    this.controls.templateSelect.innerHTML = '';

    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = 'Load Template';
    this.controls.templateSelect.appendChild(placeholder);

    var hasPreferred = false;
    for (var i = 0; i < list.length; i += 1) {
      var option = document.createElement('option');
      option.value = list[i].id;
      option.textContent = list[i].name;
      this.controls.templateSelect.appendChild(option);
      if (option.value === preferredValue) {
        hasPreferred = true;
      }
    }

    this.controls.templateSelect.value = hasPreferred ? preferredValue : '';
    this.templateSelectSignature = signature;
  };

  ScaleBarBuilder.prototype.loadTemplateFromSelection = function () {
    if (!this.controls.templateSelect) {
      return;
    }
    var templateId = String(this.controls.templateSelect.value || '').trim();
    if (!templateId) {
      this.setStatus('Select a template first.', true);
      return;
    }
    if (this.applyTemplateById(templateId)) {
      this.selectedTemplateId = templateId;
      this.syncTemplateSelector();
    }
  };

  ScaleBarBuilder.prototype.applyTemplateDefinition = function (templateDefinition, options) {
    if (!templateDefinition || !templateDefinition.state) {
      return false;
    }
    var opts = options || {};
    this.normalizeLoadedState(templateDefinition.state);
    this.refreshPresetDependentOptions(false);
    this.syncControlsFromState();
    this.syncDynamicRows();
    this.applySidebarCollapsedState();
    this.resizeCanvas();
    this.render();
    this.selectedTemplateId = String(templateDefinition.id || '');
    this.syncTemplateSelector();
    if (opts.resetHistory !== false) {
      this.initializeHistory();
    } else {
      this.commitHistory();
    }
    if (!opts.silent) {
      this.setStatus('Template applied: ' + (templateDefinition.name || templateDefinition.id) + '.', false);
    }
    return true;
  };

  ScaleBarBuilder.prototype.applyTemplateById = function (templateId, options) {
    var templateDefinition = this.getTemplateById(templateId);
    if (!templateDefinition) {
      if (!options || !options.silent) {
        this.setStatus('Template not found: ' + String(templateId), true);
      }
      return false;
    }
    return this.applyTemplateDefinition(templateDefinition, options);
  };

  ScaleBarBuilder.prototype.exportCurrentAsTemplate = function (meta, options) {
    var info = meta || {};
    var opts = options || {};
    var name = String(info.name || '').trim() || ('Template ' + String(this.templateCounter));
    var id = String(info.id || this.makeTemplateId(name, this.templateCounter)).trim();
    if (!id) {
      id = this.makeTemplateId(name, this.templateCounter);
    }
    var templateDefinition = {
      version: TEMPLATE_VERSION,
      id: id,
      name: name,
      description: String(info.description || '').trim(),
      state: this.getSerializableState({ includeMedia: !!opts.includeMedia })
    };
    if (opts.register !== false) {
      this.registerTemplateDefinitions(templateDefinition, {
        replaceExisting: true,
        persist: opts.persist !== false
      });
    }
    return deepClone(templateDefinition);
  };

  ScaleBarBuilder.prototype.importTemplateJson = function (rawText, options) {
    var opts = options || {};
    var parsed = parseJsonObject(String(rawText || ''));
    if (!parsed) {
      return { added: 0, updated: 0, skipped: 0, total: this.templateLibrary.length, error: 'invalid_json' };
    }

    var definitions = [];
    if (Array.isArray(parsed)) {
      definitions = parsed;
    } else if (Array.isArray(parsed.templates)) {
      definitions = parsed.templates;
    } else {
      definitions = [parsed];
    }

    var result = this.registerTemplateDefinitions(definitions, {
      replaceExisting: opts.replaceExisting !== false,
      persist: opts.persist !== false
    });
    if (!opts.silent) {
      this.setStatus('Templates imported. Added: ' + result.added + ', updated: ' + result.updated + '.', false);
    }
    return result;
  };

  ScaleBarBuilder.prototype.exportTemplateJson = function (options) {
    var opts = options || {};
    var includeMedia = !!opts.includeMedia;
    var allowedIds = null;
    if (Array.isArray(opts.ids) && opts.ids.length) {
      allowedIds = {};
      for (var i = 0; i < opts.ids.length; i += 1) {
        allowedIds[String(opts.ids[i])] = true;
      }
    }

    var templates = [];
    for (var j = 0; j < this.templateLibrary.length; j += 1) {
      var item = this.templateLibrary[j];
      if (!item || !item.id || !item.state) {
        continue;
      }
      if (allowedIds && !allowedIds[item.id]) {
        continue;
      }
      var out = deepClone(item);
      out.version = TEMPLATE_VERSION;
      if (!includeMedia) {
        stripMediaFromStateSnapshot(out.state);
      }
      templates.push(out);
    }

    return JSON.stringify({
      version: TEMPLATE_VERSION,
      exportedAt: Date.now(),
      count: templates.length,
      templates: templates
    }, null, 2);
  };

  ScaleBarBuilder.prototype.normalizeLoadedState = function (loadedState) {
    if (!loadedState || typeof loadedState !== 'object') {
      return;
    }
    var baseState = this.defaultState && typeof this.defaultState === 'object'
      ? this.defaultState
      : this.state;
    var merged = deepClone(baseState);
    var keys = Object.keys(loadedState);
    for (var i = 0; i < keys.length; i += 1) {
      merged[keys[i]] = loadedState[keys[i]];
    }
    this.state = merged;
    this.state.sessionVersion = SESSION_VERSION;
    this.state.cutInsetsMm = this.sanitizeCutInsets(this.state.cutInsetsMm);
    this.state.cutShape = this.state.cutShape || { vertices: [], bbox: { xMm: 0, yMm: 0, wMm: 0, hMm: 0 } };
    this.state.cutEditMode = this.state.cutEditMode || 'auto';
    this.state.cutShapeMode = this.sanitizeCutShapeMode(this.state.cutShapeMode);
    this.state.cutCircle = this.sanitizeCutCircle(this.state.cutCircle);
    this.state.cutManual = this.sanitizeCutManual(this.state.cutManual);
    this.state.exportPdfSettings = this.sanitizeExportPdfSettings(this.state.exportPdfSettings);
    this.state.cutMoveUnlocked = !!this.state.cutMoveUnlocked;
    this.state.backgroundNoise = this.sanitizeBackgroundNoise(this.state.backgroundNoise);
    this.state.shareWarnings = [];
    this.state.sidebarCollapsed = !!this.state.sidebarCollapsed;
    this.state.autosaveEnabled = this.state.autosaveEnabled !== false;
    this.state.viewZoom = clamp(parseNumber(this.state.viewZoom, 1), 0.35, 8);
    this.state.viewCenterXmm = Number.isFinite(this.state.viewCenterXmm) ? this.state.viewCenterXmm : null;
    this.state.viewCenterYmm = Number.isFinite(this.state.viewCenterYmm) ? this.state.viewCenterYmm : null;
    this.state.snapGridMm = this.normalizeSnapGridMmForUnit(this.state.snapGridMm, this.state.unitSystem);
    this.state.snapGridDivisions = this.normalizeSnapGridDivisions(this.state.snapGridDivisions);
    this.state.commandUnitMode = this.sanitizeCommandUnitMode(this.state.commandUnitMode);
    this.state.realityScanOutputMode = this.sanitizeRealityScanOutputMode(this.state.realityScanOutputMode);
    this.state.filterAprilTagCenters = this.state.filterAprilTagCenters !== false;
    this.validTagIdListCache = {};
    this.ensureTagCollection(false);
    this.ensureTagSizes();
    this.state.tagSizeMm = this.getTagSizeMm(0);
    this.state.originTagIndex = clamp(parseInt(this.state.originTagIndex, 10) || 0, 0, Math.max(0, this.state.tagCount - 1));
    if (!this.state.homePoint || typeof this.state.homePoint !== 'object') {
      var fallbackTag = this.state.tags[this.state.originTagIndex] || this.state.tags[0];
      if (fallbackTag) {
        this.state.homePoint = { xMm: fallbackTag.xMm, yMm: fallbackTag.yMm, visible: true };
      } else {
        var paper = this.getPaper();
        this.state.homePoint = { xMm: paper.width / 2, yMm: paper.height / 2, visible: true };
      }
    }
    this.state.homeSetMode = false;
    this.ensureHomePoint();
    if (!Array.isArray(this.state.overlayItems) || this.state.overlayItems.length === 0) {
      this.initDefaultOverlays();
    }
    if (!Array.isArray(this.state.references)) {
      this.state.references = [];
    }
    for (var r = 0; r < this.state.references.length; r += 1) {
      var refItem = this.state.references[r];
      if (!refItem || typeof refItem !== 'object') {
        continue;
      }
      refItem.visible = refItem.visible !== false;
      refItem.showScaleNumbers = !!refItem.showScaleNumbers;
      refItem.unitSystem = String(refItem.unitSystem || this.state.unitSystem || 'metric') === 'imperial' ? 'imperial' : 'metric';
      refItem.showUnitLabelInside = !!refItem.showUnitLabelInside;
    }

    var maxOverlayCounter = 1;
    for (var j = 0; j < this.state.overlayItems.length; j += 1) {
      var ov = this.state.overlayItems[j];
      if (ov && ov.type === 'info') {
        var hadLegacyHiddenInfo = ov.visible === false;
        ov.visible = true;
        if (hadLegacyHiddenInfo) {
          ov.opacity = INFO_OVERLAY_DIMMED_OPACITY;
        } else {
          ov.opacity = clamp(parseNumber(ov.opacity, 1), INFO_OVERLAY_DIMMED_OPACITY, 1);
        }
      }
      if (ov && ov.type === 'text') {
        ov.fontSizePt = this.getOverlayFontSizePt(ov);
      }
      if (ov && ov.type === 'shape') {
        ov.shapeKind = ov.shapeKind || 'rectangle';
        ov.fillColor = ov.fillColor || '#000000';
        ov.strokeColor = ov.strokeColor || '#000000';
        ov.strokeWidthMm = clamp(parseNumber(ov.strokeWidthMm, 0.4), 0, 20);
        ov.rows = clamp(Math.round(parseNumber(ov.rows, 4)), 1, 32);
        ov.cols = clamp(Math.round(parseNumber(ov.cols, 4)), 1, 32);
        ov.ringCount = clamp(Math.round(parseNumber(ov.ringCount, 3)), 1, 20);
        ov.spokeCount = clamp(Math.round(parseNumber(ov.spokeCount, 8)), 1, 64);
        ov.armRatio = clamp(parseNumber(ov.armRatio, 0.24), 0.12, 0.8);
        ov.showCoordinates = !!ov.showCoordinates;
      }
      var m = /overlay-(?:text|image|shape)-(\d+)/.exec(ov.id || '');
      if (m) {
        maxOverlayCounter = Math.max(maxOverlayCounter, parseInt(m[1], 10) + 1);
      }
    }
    this.overlayCounter = maxOverlayCounter;

    var maxRefCounter = 1;
    for (var k = 0; k < this.state.references.length; k += 1) {
      var rm = /ref-(\d+)/.exec(this.state.references[k].id || '');
      if (rm) {
        maxRefCounter = Math.max(maxRefCounter, parseInt(rm[1], 10) + 1);
      }
    }
    this.referenceCounter = maxRefCounter;
  };

  ScaleBarBuilder.prototype.saveSessionToLocal = function (manual) {
    try {
      var withMedia = this.getSerializableState({ includeMedia: true });
      var payload = {
        version: SESSION_VERSION,
        savedAt: Date.now(),
        state: withMedia
      };
      var text = JSON.stringify(payload);
      if (text.length > MAX_SESSION_BYTES) {
        payload.state = this.getSerializableState({ includeMedia: false });
        text = JSON.stringify(payload);
        this.setStatus('Session saved without embedded image media (size limit).', false);
      } else if (manual) {
        this.setStatus('Session saved.', false);
      }
      localStorage.setItem(SESSION_STORAGE_KEY, text);
      document.cookie = 'sbb_session_present=1; path=/; SameSite=Lax';
      this.state.lastSavedAt = payload.savedAt;
    } catch (error) {
      this.setStatus('Unable to save session locally.', true);
    }
  };

  ScaleBarBuilder.prototype.buildDesignExportPayload = function () {
    var payload = {
      version: SESSION_VERSION,
      savedAt: Date.now(),
      state: this.getSerializableState({ includeMedia: true })
    };
    var text = JSON.stringify(payload);
    if (text.length > MAX_SESSION_BYTES) {
      payload.state = this.getSerializableState({ includeMedia: false });
      payload.mediaOmitted = true;
    }
    return payload;
  };

  ScaleBarBuilder.prototype.downloadDesignFile = function () {
    var payload = this.buildDesignExportPayload();
    var text = JSON.stringify(payload, null, 2);
    var blob = new Blob([text], { type: 'application/json' });
    var url = URL.createObjectURL(blob);
    var link = document.createElement('a');
    var date = new Date();
    var stamp = date.getFullYear() + '-' +
      String(date.getMonth() + 1).padStart(2, '0') + '-' +
      String(date.getDate()).padStart(2, '0') + '_' +
      String(date.getHours()).padStart(2, '0') +
      String(date.getMinutes()).padStart(2, '0');
    link.href = url;
    link.download = 'scale-bar-design-' + stamp + '.sbb.json';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    this.setStatus(payload.mediaOmitted ? 'Design downloaded (without embedded image media due to size).' : 'Design downloaded.', false);
  };

  ScaleBarBuilder.prototype.loadDesignFile = function (file) {
    var self = this;
    if (!file) {
      return;
    }
    var reader = new FileReader();
    reader.onload = function () {
      var parsed = parseJsonObject(String(reader.result || ''));
      if (!parsed || parsed.version !== SESSION_VERSION || !parsed.state) {
        self.setStatus('Invalid design file.', true);
        return;
      }
      self.normalizeLoadedState(parsed.state);
      self.state.lastSavedAt = parsed.savedAt || null;
      self.refreshPresetDependentOptions(false);
      self.syncControlsFromState();
      self.syncDynamicRows();
      self.applySidebarCollapsedState();
      self.resizeCanvas();
      self.render();
      self.initializeHistory();
      self.setStatus('Design loaded from file.', false);
    };
    reader.onerror = function () {
      self.setStatus('Unable to read design file.', true);
    };
    reader.readAsText(file);
  };

  ScaleBarBuilder.prototype.queueAutosave = function () {
    if (this.suspendAutosave || !this.state.autosaveEnabled) {
      return;
    }
    if (this.saveDebounceTimer) {
      clearTimeout(this.saveDebounceTimer);
    }
    var self = this;
    this.saveDebounceTimer = setTimeout(function () {
      self.saveDebounceTimer = null;
      self.saveSessionToLocal(false);
    }, 800);
  };

  ScaleBarBuilder.prototype.loadSessionFromLocal = function () {
    try {
      var raw = localStorage.getItem(SESSION_STORAGE_KEY);
      if (!raw) {
        return false;
      }
      var parsed = JSON.parse(raw);
      if (!parsed || parsed.version !== SESSION_VERSION || !parsed.state) {
        return false;
      }
      this.normalizeLoadedState(parsed.state);
      this.state.lastSavedAt = parsed.savedAt || null;
      this.setStatus('Session loaded.', false);
      return true;
    } catch (error) {
      this.setStatus('Failed to load local session.', true);
      return false;
    }
  };

  ScaleBarBuilder.prototype.resetLocalSession = function () {
    try {
      localStorage.removeItem(SESSION_STORAGE_KEY);
      document.cookie = 'sbb_session_present=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax';
    } catch (error) {
      this.setStatus('Unable to clear session.', true);
      return;
    }
    var preservedSoftwarePreset = this.state.softwarePreset || 'generic';
    var preservedTagFamily = this.state.tagFamily || '';
    var preservedUnitSystem = this.state.unitSystem === 'imperial' ? 'imperial' : 'metric';

    this.suspendAutosave = true;
    this.suspendHistory = true;

    this.normalizeLoadedState(deepClone(this.defaultState || {}));
    this.state.softwarePreset = preservedSoftwarePreset;
    this.state.tagFamily = preservedTagFamily;
    this.state.unitSystem = preservedUnitSystem;
    this.state.tagType = this.getTagTypeForFamily(this.state.tagFamily, this.getCurrentPreset());
    this.refreshPresetDependentOptions(false);
    this.ensureTagCollection(true);
    this.resetHomePoint();
    this.syncControlsFromState();
    this.syncDynamicRows();
    this.applySidebarCollapsedState();
    this.resizeCanvas();
    this.render();

    this.suspendHistory = false;
    this.suspendAutosave = false;
    this.initializeHistory();
    this.queueAutosave();

    this.setStatus('Draft reset. Current software and family kept.', false);
    if (location.hash) {
      location.hash = '';
    }
  };

  ScaleBarBuilder.prototype.buildSharePayload = function () {
    var shareState = this.buildShareStateSnapshot(this.state, false);
    return {
      v: SHARE_VERSION,
      s: this.packShareState(shareState)
    };
  };

  ScaleBarBuilder.prototype.buildShareHashString = function () {
    var payload = this.buildSharePayload();
    return SHARE_HASH_PREFIX + lzCompressToUriSafe(JSON.stringify(payload));
  };

  ScaleBarBuilder.prototype.getTemplateExportDefaultName = function () {
    var preset = this.getCurrentPreset();
    var presetLabel = preset && preset.label ? preset.label : 'Scale Bar';
    var typeLabel = this.getTagTypeLabel();
    var familyLabel = this.getTagFamilyLabel();
    var paper = this.getPaper();
    return [presetLabel, typeLabel, familyLabel, paper.label].join(' | ');
  };

  ScaleBarBuilder.prototype.buildTemplateExportDetails = function () {
    var nameInput = this.controls.templateExportName;
    var idInput = this.controls.templateExportId;
    var descriptionInput = this.controls.templateExportDescription;

    var name = String(nameInput && nameInput.value || '').trim();
    if (!name) {
      name = this.getTemplateExportDefaultName();
      if (nameInput) {
        nameInput.value = name;
      }
    }

    var id = String(idInput && idInput.value || '').trim();
    if (!id) {
      id = this.makeTemplateId(name, this.templateCounter);
      if (idInput) {
        idInput.value = id;
      }
    }

    return {
      version: TEMPLATE_VERSION,
      id: id,
      name: name,
      description: String(descriptionInput && descriptionInput.value || '').trim(),
      shareHash: this.buildShareHashString()
    };
  };

  ScaleBarBuilder.prototype.copyTemplateExportDetails = function () {
    if (!this.controls.templateExportOutput) {
      return;
    }
    var details = this.buildTemplateExportDetails();
    var text = JSON.stringify(details, null, 2);
    this.controls.templateExportOutput.value = text;

    var self = this;
    var setCopyStatus = function (copied) {
      if (copied) {
        self.setStatus('Template details copied to clipboard.', false);
        return;
      }
      self.setStatus('Template details generated. Clipboard blocked, copy manually.', true);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(function () {
        setCopyStatus(true);
      }).catch(function () {
        var copiedByExec = false;
        try {
          self.controls.templateExportOutput.focus();
          self.controls.templateExportOutput.select();
          copiedByExec = document.execCommand && document.execCommand('copy');
        } catch (error) {
          copiedByExec = false;
        }
        setCopyStatus(!!copiedByExec);
      });
      return;
    }

    var copied = false;
    try {
      this.controls.templateExportOutput.focus();
      this.controls.templateExportOutput.select();
      copied = document.execCommand && document.execCommand('copy');
    } catch (error) {
      copied = false;
    }
    setCopyStatus(!!copied);
  };

  ScaleBarBuilder.prototype.applyShareHash = function () {
    location.hash = this.buildShareHashString().replace(/^#/, '');
    var shareUrl = location.href;
    var self = this;
    var done = function (ok) {
      self.setStatus(ok ? 'Share URL copied to clipboard.' : 'Share URL ready in address bar (copy manually).', !ok);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(shareUrl).then(function () {
        done(true);
      }).catch(function () {
        done(false);
      });
      return;
    }
    done(false);
  };

  ScaleBarBuilder.prototype.loadStateFromHash = function () {
    var hash = String(location.hash || '');
    if (!hash || hash.indexOf(SHARE_HASH_PREFIX) !== 0) {
      return false;
    }
    try {
      var state = this.extractStateFromShareHash(hash);
      if (!state) {
        return false;
      }
      this.normalizeLoadedState(state);
      this.setStatus('Shared layout loaded from URL.', false);
      return true;
    } catch (error) {
      this.setStatus('Share URL payload could not be parsed. Falling back to local session.', true);
      return false;
    }
  };

  ScaleBarBuilder.prototype.restoreInitialState = function () {
    var loadedFromHash = this.loadStateFromHash();
    if (!loadedFromHash) {
      this.loadSessionFromLocal();
    }
    this.refreshPresetDependentOptions(false);
  };

  
})();
